import React from 'react'
import Layout from '../components/layout'
import EnquiryForm from '../components/EnquiryForm'

const IndexPage = () => {
	return (
		<Layout>
			<div className="container">
				<div className="columns">
					{/* CONTENT */}
					<main className="main column is-three-quarters-desktop">
						<div className="content">
							<div className="columns">
								<div className="column is-one-quarter-desktop">
									<h1 className="title">Free Demo</h1>
								</div>
								<div className="column">
									<h2>Book your FREE Demo today! 🐬</h2>
								</div>
							</div>
						</div>
						<EnquiryForm formName={'book-a-demo'} country={'AU'} />
						<div className="content">
							<br />
							<ul>
								<li>
									<b>Under 30 minutes</b> – you can ask us as many questions as
									you want about the Dolphin
								</li>
								<li>
									<b>No Trespassing</b> – with your permission we’ll go directly
									to your pool and show you the benefits of owning a Dolphin
									robot
								</li>
								<li>
									<b>Availability</b> – our dealers come to you 6-days a week
									(Monday to Saturday) 8am to 5pm
								</li>
								<li>
									<b>Independent and local</b> – we’re proud to support
									independent and local businesses who will provide you with
									exceptional service, support and product information
								</li>
								<li>
									<b>Clear Pool</b> – demos can’t be performed in a green/dirty
									pool.
								</li>
							</ul>
							<br />
							<h3>Fair Demo Policy</h3>
							<i>
								Poolwerx endeavours to demo our products to all genuine clients
								on the understanding there is an intent to purchase following a
								successful demonstration that meets the needs and expectations
								of the customer.
							</i>
						</div>
					</main>
				</div>
			</div>
		</Layout>
	)
}

export default IndexPage
